import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { IPackage } from '../../@types/package'
import { THEME } from '../../global'

interface IPackageCardProps {
  data: IPackage
}

export function PackageCard({ data }: IPackageCardProps) {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center w-full p-6 mb-4 pb-4 bg-tertiary rounded-lg">
      <div className="flex w-full mb-4">
        <img className="w-8" src="/packageIcon.svg" alt="package icon" />

        <div className="mx-2">
          <div className="flex items-end">
            <p className="text-5xl font-black">{data.price}</p>
            <span className="text-md">.00Mt</span>
          </div>
          <p className="text-sm text-[#A3A3A3]">Válido por 1 mês</p>
        </div>
      </div>
      <div className="w-full mb-2">
        {data.resources.map((resource, index) => (
          <PackageResource key={index} resource={resource} />
        ))}
      </div>

      <Button
        onClick={() => navigate(`checkout/${data.price}`)}
        type="button"
        fullWidth
        variant="contained"
        sx={{
          bgcolor: THEME.colors.success,
          borderRadius: 2,
          mt: 2,
          mb: 2,
          width: '70%',
        }}
      >
        <p className="text-lg capitalize ">Comprar</p>
      </Button>
    </div>
  )
}

function PackageResource({ resource }: { resource: string }) {
  return (
    <div className="flex mb-2">
      <CheckCircleIcon
        sx={{
          color: THEME.colors.primary,
          mr: 1,
        }}
      />
      <p>{resource}</p>
    </div>
  )
}
